import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
import Auth from 'hexabase-sdk/dist/auth/auth';
import { LoginRequest } from 'types';

class UserService {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  login({ username, password }: LoginRequest) {
    const auth = new Auth();
    return auth.loginAsync({ email: username, password: password });
  }
  getUserInfo(): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      url: `userinfo`,
      method: 'GET',
    };
    return this.axios(request);
  }
  getListApplicationsByWorkspaceId(param: string) {
    const request: AxiosRequestConfig = {
      url: `workspaces/${param}/applications`,
      method: 'GET',
    };
    return this.axios(request);
  }
}

export default UserService;
